import React from 'react';
import { MailIcon } from 'lucide-react';
export function SubmitContent() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2289">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2290">
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border text-center" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2291">
          <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" style={{
          backgroundColor: 'rgba(200,168,75,0.15)'
        }} data-id="element-2292">
            <MailIcon size={24} style={{
            color: '#c8a84b'
          }} data-id="element-2293" />
          </div>
          <h2 className="text-2xl font-bold uppercase mb-2" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2294">
            Contribute to The Manual
          </h2>
          <p className="text-base text-gray-600 mb-4 max-w-lg mx-auto" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2295">
            We're always interested in improving this publication with
            member-provided content. Send your ideas, notes, rough drafts, or
            finished pieces to:
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-2296">
            <a href="mailto:Newsletter@fentonlakes.com" className="inline-flex items-center gap-2 px-4 py-2 rounded-lg font-semibold text-sm transition-all hover:opacity-80" style={{
            backgroundColor: 'rgba(30,61,47,0.08)',
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2297">
              <MailIcon size={16} data-id="element-2298" />
              Newsletter@fentonlakes.com
            </a>
            <a href="mailto:ClubPresident@fentonlakes.com" className="inline-flex items-center gap-2 px-4 py-2 rounded-lg font-semibold text-sm transition-all hover:opacity-80" style={{
            backgroundColor: 'rgba(30,61,47,0.08)',
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2299">
              <MailIcon size={16} data-id="element-2300" />
              ClubPresident@fentonlakes.com
            </a>
          </div>
        </div>
      </div>
    </div>;
}